/**
 * Part of dvcn project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@main';

// @see https://htmldom.dev/drag-to-scroll/

const $scrollWrapper = $('.c-history');

let pos = { top: 0, left: 0, x: 0, y: 0 };

function mouseDownHandler(e) {
  $scrollWrapper.css('cursor', 'grabbing');
  $scrollWrapper.css('user-select', 'none');

  pos = {
    // The current scroll
    left: $scrollWrapper.scrollLeft(),
    top: $scrollWrapper.scrollTop(),
    // Get the current mouse position
    x: e.clientX,
    y: e.clientY,
  };

  $scrollWrapper.on('mousemove', mouseMoveHandler);
  $scrollWrapper.on('mouseup', mouseUpHandler);
}

$scrollWrapper.on('mousedown', mouseDownHandler);

function mouseMoveHandler(e) {
  // How far the mouse has been moved
  const dx = e.clientX - pos.x;
  const dy = e.clientY - pos.y;

  // Scroll the element
  $scrollWrapper.scrollTop(pos.top - dy);
  $scrollWrapper.scrollLeft(pos.left - dx);
}

function mouseUpHandler(e) {
  $scrollWrapper.off('mousemove', mouseMoveHandler);
  $scrollWrapper.off('mouseup', mouseUpHandler);

  $scrollWrapper.css('cursor', '');
  $scrollWrapper.css('user-select', '');
}
